import React from 'react';
import { useSelector } from 'react-redux';

import { RootState } from '@/src/reducers/types';

import Item from './Item/Item';

import { LibraryTagsFilter } from '../../Header/TagsFilter/LibraryTagsFilter';
import DefaultMultipleActions from '../MultipleActions/MultipleActions';

interface HeaderProps {
  MultipleActionsComponent?: React.ComponentType;
  SelectAllComponent?: React.ReactNode;
}

const Header = ({
  MultipleActionsComponent = DefaultMultipleActions,
  SelectAllComponent,
}: HeaderProps) => {
  const files = useSelector((state: RootState) => state.files);

  return (
    <React.Fragment>
      <MultipleActionsComponent />
      <div className="filesListHeader">
        <div className="listRow">
          <div className="listItem">
            {(files.activeInSidebar.id !== 'library' || files.activeInSidebar.id === 'library') &&
              SelectAllComponent}
            <Item column="name" label="Name" sortingType="alphabetical" disableFilters />
          </div>
          <div className="listItem">
            <Item
              column="uploadedBy"
              label="Uploaded By"
              sortingType="alphabetical"
              disableFilters
            />
          </div>
          <div className="listItem">
            <Item
              column="uploadDate"
              label="Uploaded Date"
              sortingType="chronological"
              disableFilters
            />
          </div>
          <div className="listItem">
            <LibraryTagsFilter />
          </div>
          <div className="listItem filesActionContainer">
            {/* this is a handle for an empty column */}
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default Header;
